import { WEBEX_TOKEN_LOADING, WEBEX_TOKEN_LOAD_ERROR, WEBEX_TOKEN_LOAD_SUCCESS } from "../actions/action_types";

export default function webexTokenReducer(state = {tokens: null, isLoading:false, error: null}, action){
    switch(action.type){
        case WEBEX_TOKEN_LOADING:
            return {...state, isLoading:true}
        case WEBEX_TOKEN_LOAD_SUCCESS:
            return {...state, isLoading:false, tokens:action.payload}
        case WEBEX_TOKEN_LOAD_ERROR:
            return {...state, isLoading:false, error:action.payload}
        default:
            return state
    }
}